export const getTranslateX = (singleSlideWidth: number, currentIndex: number) => {
    return -singleSlideWidth * currentIndex;
};
